<div *ngIf="registration" class="d-flex align-items-center justify-content-center gap-0 flex-column"
    style="width: 40px;" (click)="VoteCycle()">
    <mat-icon data-nosnippet *ngIf="VotedUp()" class="mat-icon pointer i-center fs-mb-30 fs-md-35"
        style="height: 15px; color: #64AF96;">&#xe5c7;</mat-icon>

    <mat-icon data-nosnippet *ngIf="UnVoted() || VotedDown()" class="mat-icon pointer i-center fs-mb-30 fs-md-35"
        style="height: 15px; color: #9D9D9D;">&#xe5c7;</mat-icon>
    <small [ngStyle]="{'color': UnVoted() ? '#6c757d' : VotedDown() ? '#E87676' : '#64AF96' }"
        [ngClass]="{'fw-bolder': !UnVoted(), 'fw-normal': UnVoted() }" class="my-0 text-center lh-sm">{{ UnVoted() ?
        'Vote' : VotedUp()
        ? 'Voted' : 'Voted' }}</small>
    <mat-icon data-nosnippet *ngIf="UnVoted() || VotedUp()" class="mat-icon pointer i-center fs-mb-30 fs-md-35"
        style="height: 15px; color: #9D9D9D;">&#xe5c5;</mat-icon>

    <mat-icon data-nosnippet *ngIf="VotedDown()" class="mat-icon pointer i-center fs-mb-30 fs-md-35"
        style="height: 15px; color: #E87676;">&#xe5c5;</mat-icon>
</div>